<!--
* UIID: UI-DLB-ID-100
* UI Name: Identification
* Modify Date: 2020/06/18
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{$t('lbl.identification.page_header')}}</v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <!-- /**
     * 2021.07.26 203737 SPKA-161 issue 110 Change all text field and combo box style for search condition [Management]
     */ -->
    <v-row class="custom-form-control custom-figma-1 mb-0">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{$t('btn.common.collapseConditions')}}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{$t('btn.common.expandConditions')}}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col class="comm-header-col data-query-section custom-field-combo custom-figma-1 pb-0 pt-0 mt-0" cols="12" lg="9" md="9">
            <v-row>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0">
                <v-text-field
                  v-model="srcEdiId"
                  dense
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.findbyEDIID')"
                  @keyup.enter="searchData"
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="srcCompId"
                  :items="compList"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.selectCompany')"
                  @keyup.enter="searchData"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="pt-0 pb-0 pr-24px">
                <v-autocomplete
                  v-model="srcPrnrId"
                  :items="prnrList"
                  dense
                  filled
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.selectPartner')"
                  @keyup.enter="searchData"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right"
            cols="12"
            lg="3"
            md="3"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
              <v-btn class="btn btn-top btn-search btn-width-1" color="primary" @click="searchData">
                <v-icon x-small class="mr-1">fa fa-search</v-icon>
                {{$t('btn.common.search')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Button Action -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  @click="openAddIdentification(null,'Add')"
                  :disabled="!$auth.manage"
                  class="btn btn-add"
                >
                  {{$t('btn.common.add')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"></v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  height="40"
                  hide-details
                  dense
                  solo
                  @change="searchByFilter"
                  :items="searchByItems"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  heigth="40"
                  append-icon="fa fa-search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  hide-details
                  dense
                  solo
                  @input="searchByFilter"
                  @click:append="searchByFilter"
                  v-on:keyup.enter="searchByFilter"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <!-- 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          class="list-table text-center-table code-table srm-list-table custom-border-table"
          :footer-props="{showFirstLastPage: true}"
          hide-default-footer
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
        >
          <!-- // 2021.9.21 203728 change to select row as Code Table -->
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="(item) in items"
                :key="item.id"
                @click="onClickRow(item)"
                :class="[selectedRow === item.id ? 'selected_row' : '']"
              >
                <td class="col-id">{{item.srId}}</td>
                <td>{{item.srQlfr}}</td>
                <td>{{item.orgCompId}}</td>
                <td>{{item.orgPrnrId}}</td>
                <td>{{item.compNm}}</td>
                <td>{{item.cnttPrn}}</td>
                <!-- <td>{{item.email}}</td> -->
                <td class="text-center">
                  <v-btn small text icon @click="openAddIdentification(item, 'Edit')">
                    <icon-svg :disabled="!$auth.manage" iconName="edit"/>
                  </v-btn>
                  <v-btn small text icon @click="deleteItem(item)" :disabled="!$auth.manage">
                    <icon-svg :disabled="!$auth.manage" iconName="delete"/>
                  </v-btn>
                </td>
                <td class="text-center">{{item.updDt}}</td>
                <td>{{item.updUsrId}}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <dialogWindow
        ref="ediIdDialog"
        size="max"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="removeDialog({})"
      >
    </dialogWindow>
    <!-- 2021.11.25 213960 change page function position, change v-pagination to custom pagination, add button first last -->
    <v-row v-show="totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox">
                  </v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ (itemsPerPage * (page-1)) + 1 }} ~ {{ totalCnt - itemsPerPage*page > 0 ? itemsPerPage*page : totalCnt }} of {{ totalCnt }}
                  </v-label>
                </div>
                <button type="button" @click="handlePageChange(1)" :class="['custom-btn-first-last-paging', page == 1 ? ' v-pagination__navigation--disabled': $vuetify.theme.dark ? '' : 'white']">
                  <div class="ml-2 pr-2 d-inline"><span><i class="fa fa-sm fa-step-backward"></i></span></div>
                </button>
                <button type="button" @click="changePageByTextbox(-1)" :class="['mr-3 custom-btn-first-last-paging', page-1 < 1 ? ' v-pagination__navigation--disabled': $vuetify.theme.dark ? '' : 'white']">
                  <div class="ml-2 pr-2 d-inline"><span><i class="fa fa-lg fa-caret-left"></i></span></div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field><label>/ {{pageCount}}</label>
                <button type="button" @click="changePageByTextbox(1)" :class="['ml-3 custom-btn-first-last-paging', page+1 > pageCount ? ' v-pagination__navigation--disabled': $vuetify.theme.dark ? '' : 'white']">
                  <div class="mr-2 pl-2 d-inline"><span><i class="fa fa-lg fa-caret-right"></i></span></div>
                </button>
                <button type="button" @click="handlePageChange(pageCount)" :class="['custom-btn-first-last-paging', page == pageCount ? ' v-pagination__navigation--disabled': $vuetify.theme.dark ? '' : 'white']">
                  <div class="mr-2 pl-2 d-inline"><span><i class="fa fa-sm fa-step-forward"></i></span></div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <add-identificationin-dialog
        v-if="dialog.type == 'addIdentification'"
        class="custom-dialog mapper-version"
        :id="dialog.id"
        :ref='"dialog-" + dialog.id'
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :indexType="editedIndex"
        :paramItem="ediItems"
        :refeshList="searchData"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
      ></add-identificationin-dialog>
      <versionHistory
        v-if="dialog.type == 'versionHistory'"
        class="custom-dialog mapper-version"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :id="dialog.id"
        title="Communication"
      ></versionHistory>
    </div>
    <dialogWindow
      ref="deleteDialog"
      :info="editedItem.name"
      size="max"
      title="Delete Communication"
      :detail="$t('msg.identification.deleteIdentification')"
      color="confirmation"
      :showCancel="true"
      @select-ok="onDeleteItem(editedItem)"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import addIdentificationinDialog from "@/vue-caas/views/ediid/AddIdentification.vue";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import $ from "jquery";
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import { mapState } from "vuex";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
import versionHistory from "@/vue-caas/components/DelHistoryWorkflowDialog.vue";
import IconSvg from  '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import EventBus from "@/vue-caas/views/process/component/event-bus.js";

  export default {
    components: {
      dialogWindow,
      addIdentificationinDialog,
      SystemProgress,
      versionHistory,
      IconSvg
    },
    props: {
      items: {
        default: Array,
      },
    },

    data(){
      return{
      tableHeight:'',
      isCreated: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      searchBy: 'all',
      searchByTxt: '',
      detailDialog: false,
      srcEdiId: '',
      srcCompId: '',
      srcPrnrId: '',
      headers: [],
      listData: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialogs: [],
      editedIndex: -1,
      editedItem: {
        srId: '',
        compId: '',
        remark: '',
      },
      ediItems: null,
      inputDisplay: "d-none",
      checkDialog: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      checkDialogTitle: 'Alert',
      rowPerPage: [
        {value: 10, text: 'Show 10'},
        {value: 25, text: 'Show 25'},
        {value: 50, text: 'Show 50'},
        {value: 75, text: 'Show 75'},
        {value: 100, text: 'Show 100'}
      ],
      searchByItems: [
        { text: this.$t("lbl.common.searchTypePlaceHolder"), value: 'all' },
        { text: 'EDI ID', value: 'srId' },
        { text: 'Company ID', value: 'orgCompId' },
        { text: 'Partner ID', value: 'orgPrnrId' },
        { text: 'Company Name', value: 'compNm' },
        { text: 'Contact Person', value: 'cnttPrn' },
        { text: 'Email', value: 'email' }
      ],
      compList: [],
      compOrgList: [],
      prnrList: [],
      prnrOrgList: [],
      isLoading: true,
      // 2021.9.21 203728 change to select row as Code Table
      selectedRow: '',
      totalCnt: 0,
      pageEnter: 1,
    }},

  computed: {
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },

  watch: {
    page(){
      this.pageEnter = this.page;
    }
  },

  methods: {
    displaySearchConditions(action) {
      if(action === 'expand') {
        $(".date-query-section").css("display", "block");
        $(".data-query-section").css("display", "block");
        $(".expand-search-conditions").css("display", "none");
        $(".collapse-search-conditions").css("display", "block");
      } else {
        $(".date-query-section").css("display", "none");
        $(".data-query-section").css("display", "none");
        $(".expand-search-conditions").css("display", "block");
        $(".collapse-search-conditions").css("display", "none");
      }
    },
    // 2021.9.21 203728 change to select row as Code Table
    onClickRow(item){
      this.selectedRow = item.id;
    },
    openVersionHistory(list, val) {
      let type = "versionHistory";
      let item = {};
      item.ROWID = 0;
      item.versionList = list;
      item.comNm = val.srId;
      item.item = val;
      let indexArrDialog = this.findDialog("versionHistory_0");
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      let self = this;
      if(cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
        .dispatch("getListUseInWorkflow", { type: "EDI", value: item.id })
        .then((res) => {
          if (res.length > 0) {
            self.openVersionHistory(res, item);
          } else {
            self.$refs.deleteDialog.dialog = true;
          }
        });
      }
    },
    onDeleteItem(item) {
      this.$store.dispatch("deleteEdiId", item).then(() => {
        this.listData = this.$store.getters.ediIdList;
        this.$refs.ediIdDialog.dialog = true;
        this.checkDialogColor = "success";
        this.checkDialogInfo = this.$t(
          "msg.identification.afterDeleteIdentification"
        );
      });
    },
    searchData() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      this.searchBy = 'all';
      this.searchByTxt = '';

      const params = {
        srcEdiId: this.srcEdiId,
        srcCompId: this.srcCompId,
        srcPrnrId: this.srcPrnrId,
      };

      this.$store.dispatch('getEdiIdList', params).then(() => {
        this.listData = this.$store.getters.ediIdList;
        this.page = 1;
        this.isLoading = false;
        this.totalCnt = this.listData.length;
        this.caculatePageCount();
      }).catch((ex) => {
        this.isLoading = false;
      });
    },
    searchByFilter(str) {
      this.$store.commit('SET_STORE_EDI_ID_LIST_FILTER', {filter : this.searchBy, str : this.searchByTxt});
      this.listData = this.$store.getters.ediIdList;
      this.totalCnt = this.listData.length;
      this.caculatePageCount();
    },
    initEditedItem() {
      this.editedItem = {
        srId: '',
        compId: '',
        remark: '',
      };
    },

    openInput() {
      this.inputDisplay = '';
    },

    closeInput() {
      this.inputDisplay = 'd-none';
      this.initEditedItem();
    },

    insertItem() {
      this.initEditedItem();
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.editedItem);
      this.detailDialog = true;
      this.$refs.form.reset();
      // this.editedItem.compPrnr = 'C';
    },


    openAddIdentification (itemRow, typeActive) {
      let isEdit = false;

      if(typeActive == 'Edit'){
        this.editedIndex = 1;
        this.ediItems = Object.assign({}, itemRow);
        isEdit = true;
      }else{
        this.editedIndex = -1;
        isEdit = false;
      }
      let type = "addIdentification";
      let item = {
        ROWID : 0,
        isEdit : isEdit,
      }
      let indexArrDialog = this.findDialog("addIdentification_0");
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },

    findDialog (id, dialogs) {
      if (!dialogs) dialogs = this.dialogs
      let index = dialogs.findIndex((val) => {
        return val.id === id
      })
      return (index > -1) ? index : null
    },
    newDialog (item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },

    generateDialog (item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({id : id});
      this.dialogId++
      let name = 'Dialog ' + id
      let options = {left : 30 * this.dialogId, top : 30 * this.dialogId, item};
      return { id, name, type, options }
    },

    removeDialog (dialog) {
      let id = dialog.id
      let index = this.findDialog(id)
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1)
      if (this.selected && this.selected.id === id) this.selected = null
    },

    dialogDragEnd (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },

    selectDialog (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },
    // 2021.11.25 213960 modify page function: change page and change page size
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : (data < 1 ? 1 : data);
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    handlePageChange(value) {
      this.page = value;
    },
    caculatePageCount() {
      if(this.totalCnt % this.itemsPerPage === 0){
        this.pageCount = this.totalCnt / this.itemsPerPage;
      }else{
        this.pageCount = Math.floor(this.totalCnt / this.itemsPerPage) + 1;
      }
    },
  },

  created() {
    this.listData = this.items;

    this.headers = [
      { text: 'EDI ID', value: 'srId', width: "200" },
      { text: 'EDI Qualifier', value: 'srQlfr', width: "150" },
      { text: 'id', value: 'id',align: ' d-none', width: "200" },
      { text: 'Company ID', value: 'orgCompId', width: "200" },
      { text: 'Partner ID', value: 'orgPrnrId', width: "200" },
      { text: 'Company / Partner Name', value: 'compNm', 'min-width': "150" },
      { text: 'Contact Person', value: 'cnttPrn', width: "300" },
      // { text: 'E-mail', value: 'email', width: "315" },
      { text: 'Manage', value: 'manage', align: 'center', width: '90px', sortable:false },
      { text: 'Last Update', value: 'updDt', align: 'center', width: "170" },
      { text: 'Update User', value: 'updUsrId', align: 'left', width: "170" },
    ];

    const params = [];

    this.$store.dispatch('getApiCompanyList', params).then(() => {
      this.compOrgList = this.$store.getters.apicompanies;
      this.compList.push({text: this.$t('lbl.common.conditionSearch.all'), value: ''});
      for (let i = 0; i < this.compOrgList.length; i += 1) {
        const comp = this.compOrgList[i];
        this.compList.push({ text: `${comp.compNm} (${comp.compId})`, value: `${comp.compId}` });
      }
    });

    this.$store.dispatch('getPartnerList', params).then(() => {
      this.prnrOrgList = this.$store.getters.partnerList;
      this.prnrList.push({text: this.$t('lbl.common.conditionSearch.all'), value: ''});
      for (let i = 0; i < this.prnrOrgList.length; i += 1) {
        const prnr = this.prnrOrgList[i];
        this.prnrList.push({ text: `${prnr.prnrNm} (${prnr.prnrId})`, value: `${prnr.prnrId}` });
      }
    });

    this.searchData();
    EventBus.$on("delete-item", this.onDeleteItem);
    this.isCreated = true;
  },

  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + "px";
    })
    },
  }
</script>